/* eslint-disable react/jsx-pascal-case */
import styled from "styled-components";
import {
  BackgroundArea,
  Icon,
  RowView,
  TitleArea,
} from "../../../../Component/style/common_style";
import { modalProps } from "../../../../Component/Interface/Modal";

interface BuyCompModalOpen extends modalProps {
  onClose: () => void;
}

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 27rem;
  margin: auto 0rem;
  background-color: white;
  color: #454545;
  border-radius: 24px;
  overflow: hidden;
  padding: 24px 24px 30px 24px;
  z-index: 99;
  color: #1d1d1d;
  div.info {
    line-height: 25px;
  }
`;

const Title_Box = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
`;

const Exit_Btn = styled(Icon)`
  position: absolute;
  right: 0px;
  justify-self: flex-end;
  cursor: pointer;
`;

const Content_Box = styled.div`
  padding: 20px 0px 2px 0px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: #2d2d2d;
`;

const BtnArea = styled(RowView)`
  margin-top: 1.5rem;
  div {
    flex: 1;
    padding: 0.8rem 0rem;
    font-family: var(--font-Pretendard-SemiBold);
    text-align: center;
    color: white;
    background: linear-gradient(90deg, #7955f0, #3209b9);
    border-radius: 8px;
    cursor: pointer;
  }
`;

const Buy_Complete_Modal = (props: BuyCompModalOpen) => {
  const isOpen = props.visible;
  const setIsOpen = props.handleModal;
  const closeModal = () => {
    setIsOpen();
    props.onClose();
  };

  return (
    <BackgroundArea style={isOpen ? {} : { display: "none" }} translate="no">
      <ModalBox>
        <Title_Box>
          <div>구매완료</div>
          <Exit_Btn
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title_Box>

        <Content_Box className="info">
          구매가 완료되었습니다!
          <br />
          방송이 종료되면 카카오톡으로 정산서를 발송해 드립니다.
        </Content_Box>

        <BtnArea>
          <div onClick={closeModal}>확인</div>
        </BtnArea>
      </ModalBox>
    </BackgroundArea>
  );
};

export default Buy_Complete_Modal;
